export default __webpack_public_path__ + "static/media/LocationCodeClickingDiagram.a86155c2.png";